"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimestampFormat = void 0;
const getTimestampFormat = (timestamp) => timestamp
    ? new Date(timestamp).toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    })
    : new Date().toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
exports.getTimestampFormat = getTimestampFormat;
